import { styled } from '@mui/system';
import Image from 'next/image';

interface WarningIconProps {
  width?: number;
  height?: number;
}

const WarningIconContainer = styled('div')<WarningIconProps>(
  ({ width, height }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width,
    height: height,
  }),
);

export const WarningIcon = ({ width = 40, height = 32 }: WarningIconProps) => {
  return (
    <WarningIconContainer width={width} height={height}>
      <Image
        src="/assets/images/warningIcon.png"
        alt="Warning icon"
        width={width}
        height={height}
      />
    </WarningIconContainer>
  );
};
